import { defineMessages } from "react-intl"

export const createStockExposeModalMessages = defineMessages({
	cancel: {
		defaultMessage: "Cancel",
		id: "createStockExposeModal.cancel",
	},
	capError: {
		defaultMessage: "Customer could not be loaded from the customer module. Please enter the name manually.",
		id: "createStockExposeModal.capError",
	},
	create: {
		defaultMessage: "Create",
		id: "createStockExposeModal.create",
	},
	customerNameLabel: {
		defaultMessage: "Customer name",
		id: "createStockExposeModal.customerNameLabel",
	},
	headline: {
		defaultMessage: "Create Exposé (PDF)",
		id: "createStockExposeModal.headline",
	},
	sectionSpecialEquipment: {
		defaultMessage: "Selected Equipment",
		id: "createStockExposeModal.sectionSpecialEquipment",
	},
	sectionStandardEquipment: {
		defaultMessage: "Standard Equipment",
		id: "createStockExposeModal.sectionStandardEquipment",
	},
	sectionTechnicalData: {
		defaultMessage: "Technical data",
		id: "createStockExposeModal.sectionTechnicalData",
	},
	sectionTyreLabels: {
		defaultMessage: "Tyre Labels",
		id: "createStockExposeModal.sectionTyreLabels",
	},
	sectionVehicleImages: {
		defaultMessage: "Vehicle images",
		id: "createStockExposeModal.sectionVehicleImages",
	},
	selectFromCap: {
		defaultMessage: "Select customer from customer module",
		id: "createStockExposeModal.selectFromCap",
	},
	subtitle: {
		defaultMessage: "Select the content you want to include in the exposé.",
		id: "createStockExposeModal.subtitle",
	},
})
